import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import PlannerInformationContainer
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableFilters/PlannerInformationPicker/PlannerInformation/PlannerInformationContainer';

const PlannerInformationPicker = ({ resource, direction }) => {
  return resource.withRelationship(
    fr.relationships.plannerTransition.name,
    (rel) => <PlannerInformationContainer link={rel.link('related')} direction={direction} />,
    () => null,
  );
};

PlannerInformationPicker.defaultProps = {
  direction: 'column',
};

PlannerInformationPicker.propTypes = {
  resource: PropTypes.object.isRequired,
  direction: PropTypes.oneOf(['row, column']),
};

export default PlannerInformationPicker;
